var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"inline":"","color":"primary","content":_vm.numberElements,"value":_vm.numberElements,"bordered":"","overlap":""}},[_vm._v(" "+_vm._s(_vm.queueTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }